import { defineComponent as _defineComponent } from 'vue'

import { BaseText, ButtonTertiary } from '@warrenbrasil/nebraska-web';


export default /*#__PURE__*/_defineComponent({
  __name: 'ErrorHandler',
  props: {
  message: {
    type: String,
    default: 'Não foi possível carregar todos os serviços.'
  },
  buttonLabel: {
    type: String,
    default: 'Tentar novamente'
  },
  loading: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: false
  }
},
  emits: ["retry"],
  setup(__props, { emit }: { emit: ({
  (event: 'retry'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props;





function handleRetry() {
  if (props.disabled || props.loading) {
    return;
  }
  emit('retry');
}

return { __sfc: true,props, emit, handleRetry, BaseText, ButtonTertiary }
}

})